import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Set } from 'immutable';

import TooltipForButton from 'components/mui/Tooltip/TooltipForButton';

import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

import { ControlLabel, Checkbox } from 'components/Tables/grid/SelectAllCheckbox/StyledComponents';
import { jeUnmatchedLineNumbersSelector, selectedRowSelector } from 'domain/journal';

const SelectUnmatchedLinesCheckbox = ({ handleChange }) => {
  const unmatchedRows = useSelector(jeUnmatchedLineNumbersSelector);
  const selectedRows = useSelector(selectedRowSelector);
  const onChange = useCallback(
    (e) => {
      const { checked } = e.currentTarget;
      const payload = checked ? unmatchedRows : new Set();
      handleChange(payload);
    },
    [handleChange, unmatchedRows],
  );

  const partiallyChecked = Boolean(selectedRows.size);
  const checked = selectedRows.equals(unmatchedRows);
  const disabled = unmatchedRows.size === 0;

  return (
    <TooltipForButton
      t={
        disabled
          ? {
              id: 'document.show.journalEntry.selectUnmatchedLines.disabled',
              defaultMessage: 'No unmatched lines',
            }
          : undefined
      }
      placement="top"
    >
      <ControlLabel
        disableTypography
        checked={partiallyChecked}
        onChange={onChange}
        disabled={disabled}
        control={
          <Checkbox
            size="small"
            checkedIcon={checked ? <CheckBoxIcon /> : <IndeterminateCheckBoxIcon />}
            disabled={disabled}
          />
        }
        label={
          <FormattedMessage
            id="document.show.journalEntry.selectUnmatchedLines"
            defaultMessage="Select unmatched lines ({count})"
            values={{ count: unmatchedRows.size }}
          />
        }
      />
    </TooltipForButton>
  );
};

export default SelectUnmatchedLinesCheckbox;
